// Custom navigation icons with partial fill states for better definition

export function CalendarNavIcon({ isActive, className = "w-6 h-6" }) {
  const color = isActive ? 'var(--link-ingredient)' : 'currentColor';
  const fillColor = isActive ? 'var(--link-ingredient)' : 'none';
  
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Calendar outline */}
      <rect x="3" y="4" width="18" height="18" rx="2" stroke={color} strokeWidth="2" fill="none" />
      {/* Top bar */}
      <line x1="3" y1="10" x2="21" y2="10" stroke={color} strokeWidth="2" />
      {/* Hanging tabs */}
      <line x1="8" y1="2" x2="8" y2="6" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <line x1="16" y1="2" x2="16" y2="6" stroke={color} strokeWidth="2" strokeLinecap="round" />
      
      {/* Calendar grid dots - filled when active */}
      {isActive && (
        <>
          <circle cx="8" cy="14" r="1" fill={fillColor} />
          <circle cx="12" cy="14" r="1" fill={fillColor} />
          <circle cx="16" cy="14" r="1" fill={fillColor} />
          <circle cx="8" cy="18" r="1" fill={fillColor} />
          <circle cx="12" cy="18" r="1" fill={fillColor} />
          <circle cx="16" cy="18" r="1" fill={fillColor} />
        </>
      )}
    </svg>
  );
}

export function BookOpenNavIcon({ isActive, className = "w-6 h-6" }) {
  const color = isActive ? 'var(--link-ingredient)' : 'currentColor';
  
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Left page outline */}
      <path
        d="M2 3h6a4 4 0 0 1 4 4v13a3 3 0 0 0-3-3H2z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Right page outline */}
      <path
        d="M22 3h-6a4 4 0 0 0-4 4v13a3 3 0 0 1 3-3h7z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      
      {/* Text lines on pages when active */}
      {isActive && (
        <>
          {/* Left page lines */}
          <line x1="4" y1="9" x2="9" y2="9" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
          <line x1="4" y1="12" x2="9" y2="12" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
          <line x1="4" y1="15" x2="9" y2="15" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
          
          {/* Right page lines */}
          <line x1="15" y1="9" x2="20" y2="9" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
          <line x1="15" y1="12" x2="20" y2="12" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
          <line x1="15" y1="15" x2="20" y2="15" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
        </>
      )}
    </svg>
  );
}

export function ShoppingCartNavIcon({ isActive, className = "w-6 h-6" }) {
  const color = isActive ? 'var(--link-ingredient)' : 'currentColor';
  
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="9" cy="21" r="1" stroke={color} strokeWidth="2" fill="none" />
      <circle cx="20" cy="21" r="1" stroke={color} strokeWidth="2" fill="none" />
      <path
        d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      
      {/* Grid lines in cart when active */}
      {isActive && (
        <>
          <line x1="8" y1="9" x2="20" y2="9" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
          <line x1="8" y1="12" x2="19" y2="12" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
          <line x1="9" y1="15" x2="18" y2="15" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
        </>
      )}
    </svg>
  );
}

export function MoreHorizontalNavIcon({ isActive, className = "w-6 h-6" }) {
  const color = isActive ? 'var(--link-ingredient)' : 'currentColor';
  
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={isActive ? color : 'none'}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <line x1="3" y1="6" x2="21" y2="6" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <line x1="3" y1="12" x2="21" y2="12" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <line x1="3" y1="18" x2="21" y2="18" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
